<template>
	<div id="container">
		<div>
			<p>Please try accessing this experience again from the AbbVie Medical Affairs Virtual Booth.</p>
		</div>
	</div>
</template>
<style scoped>
div#container {
	display: grid;
	place-items: center;
	width: 100%;
}

	p {
		color: #800000;
		font-size: 1.53rem;
		font-weight: bold;
		margin-bottom: 1.2rem;
		text-align: center;
	}
</style>